module.exports = __webpack_public_path__ + "static/media/400087_01.c5afe32a.png";